/**
 * SMP-1579. Countries come from `GET /countries` as Business Central codes ({ code, name }).
 * They are not ISO: names can be empty or repeated, so the code is always shown.
 * The label holds both name and code, so el-select's built-in filter searches on both.
 */
const countryLabel = ({ code, name }) => (name ? `${name} (${code})` : code);

export default countryLabel;
